import { useParams } from 'react-router-dom';
import { isCreatedAfterMsr3Cutoff } from '../constant/msr3ReturnBannerCopy';
import { useActiveWorkspace } from './useActiveWorkspace';
import { useCanAccessRoyalties } from './useCanAccessRoyalties';

/**
 * Whether the member has anything in MSR2 to return to (APP-2283).
 *
 * Per workspace: the same check that gates the Historic Royalties nav link,
 * plus the MSR3 cutoff. Routes without a `:workspaceId` — the profile page and
 * the `/` and `/workspace` redirects — deliberately show nothing (APP-2308).
 *
 * @param enabled Skips the membership lookup while the banner is switched off.
 */
export const useCanReturnToMsr2 = (enabled: boolean) => {
  const { workspaceId } = useParams();
  const [activeWorkspace] = useActiveWorkspace();

  // Matched against the route rather than tested for existence: the workspace
  // query keeps the previous workspace as placeholder data, so a route it does
  // not belong to still reports the one left behind.
  const routeWorkspace =
    workspaceId && activeWorkspace?._id === workspaceId
      ? activeWorkspace
      : undefined;

  const { canAccessRoyalties } = useCanAccessRoyalties(routeWorkspace, enabled);

  if (!routeWorkspace) return false;

  return (
    canAccessRoyalties && !isCreatedAfterMsr3Cutoff(routeWorkspace.created)
  );
};
